import {
  SET_FOOD_CART,
  UPDATE_FOOD_LIST_CART,
  CALCULATTING_CART,
  RESET_FOOD_CART,
  EMPTY_CART,
  FINAL_SUBMIT_CART,
  CHANGE_ADDRESS_CART,
  RESET_CART,
} from "./actionTypes";

import { calculateInvoice, changeInvoiceAddress } from "../../api/invoice";
import { setOrderStatusCalendarAction } from "../calendar/actions";
import { getUserCreditAction } from "../user/actions";
import {
  getMenuFoodItem,
  getMenuCartAction,
  emptyQuantityMenuAction,
} from "../menu/actions";
import {
  setSettingAction,
  setHasInvoiceAction,
  exitEditModeAction,
} from "../setting/actions";

const getCartMenuList = (cartItems, menuFoodList) => {
  const list = [];

  if (cartItems.length) {
    cartItems.forEach((cartItem) => {
      list.push({
        foodItemId: cartItem.foodItemId,
        quantity: cartItem.quantity,
        totalPrice: cartItem.totalPrice,
        ...menuFoodList[cartItem.foodItemId],
      });
    });
  }

  return list;
};

export const updateCartAction =
  (
    data,
    finalSubmit = false,
    companyAddressId = 0,
    companyAddressFloorId = 0,
    paymentData
  ) =>
  (dispatch, getState) => {
    if (data) {
      const state = getState();
      const menuFoodList = state.menu.foodList;
      const isEndOrderTime = state.calendar.current.isEndOrderTime;
      const isLastMomentFood = state.menu.list?.some(
        (x) => x.isLastMomentFoodItem
      );

      let list = [];
      if (
        (!finalSubmit && !isEndOrderTime) ||
        finalSubmit ||
        isLastMomentFood
      ) {
        list = getCartMenuList(data.itemList, menuFoodList);
      }

      const payload = {};
      if (companyAddressId) {
        payload.companyAddressId = companyAddressId;
        payload.companyAddressFloorId = companyAddressFloorId;
      }

      if (finalSubmit) {
        payload.paidPrice = data.totalPriceWithCalcSubside;
      }

      dispatch({
        type: SET_FOOD_CART,
        payload: {
          finalSubmit,
          list,
          totalPrice: data.totalPrice,
          totalPriceWithCalcSubside: data.totalPriceWithCalcSubside,
          subside: data.subside,
          totalQuantity: data.totalQuantity,
          paymentData,
          ...payload,
        },
      });
    } else {
      dispatch({ type: EMPTY_CART });
    }

    dispatch(setSettingAction());
  };

const getCartItems = (foodItems) => {
  return Object.keys(foodItems)
    .map((foodItemId) => {
      const { quantity } = foodItems[foodItemId];
      return (
        quantity > 0 && {
          foodItemId,
          quantity,
        }
      );
    })
    .filter((item) => item !== false);
};

let throttle;
export const calculateInvoiceAction =
  (callback = () => {}) =>
  (dispatch, getState) => {
    const state = getState();
    const foodItems = state.menu.foodItems;

    clearTimeout(throttle);
    throttle = setTimeout(() => {
      const list = getCartItems(foodItems);
      if (list.length) {
        const currentDayId = state.calendar.current.id;

        calculateInvoice({
          dayId: currentDayId,
          foodItemIdQuantityList: list,
        })
          .then((result) => {
            dispatch(updateCartAction(result.data));
            callback({ success: true });
          })
          .catch((err) => {
            let message = err.message || "خطایی رخ داده است، دوباره تلاش کنید";
            // if (err.errorCode === 'ERROR_OrderingTimeIsOver') {
            //   message = err.message;
            // }

            callback({ success: false, message });
          });
      } else {
        dispatch(submitCartAction(true, 0, 0, callback));
      }
    }, 700);
  };

export const calculattingCartAction =
  (value = true) =>
  (dispatch, getState) => {
    const calculatting = getState().cart.calculatting;
    if (calculatting !== value) {
      dispatch({ type: CALCULATTING_CART, payload: value });
    }
  };

export const resetCartFoodAction = () => (dispatch, getState) => {
  const list = getState().cart.list;
  if (list !== null) {
    dispatch({ type: RESET_FOOD_CART, payload: true });
  }
};

export const emptyCartAction = () => (dispatch, getState) => {
  const list = getState().cart.list;

  if (list?.length > 0) {
    dispatch({ type: EMPTY_CART, payload: true });
  }
};

export const beforeStoreCartAction = () => (dispatch, getState) => {
  const state = getState();

  const list = state.cart.list;
  const hasInvoice = state.setting.hasInvoice;
  const currentDayId = state.calendar.current.id;

  if (list?.length > 0) {
    if (hasInvoice) {
      dispatch(getMenuCartAction(currentDayId, true));
    } else {
      dispatch(emptyCartAction());
    }
  }
};

export const submitCartAction =
  (removeAll = false, addressId = 0, floorId, callback = () => {}) =>
  (dispatch, getState) => {
    const state = getState();
    const foodItems = state.menu.foodItems;
    const currentDayId = state.calendar.current.id;
    const hasInvoice = state.setting.hasInvoice;

    let list = [];
    if (!removeAll) {
      list = getCartItems(foodItems);
    }

    calculateInvoice({
      forSubmit: true,
      dayId: currentDayId,
      companyAddressId: addressId,
      companyAddressFloorId: floorId,
      foodItemIdQuantityList: list,
    })
      .then(() => {
        const hasOrder = list.length > 0;

        dispatch(setOrderStatusCalendarAction(currentDayId, hasOrder));

        let message = null;
        if (removeAll) {
          dispatch({ type: EMPTY_CART });

          if (hasInvoice) {
            message = "سفارش شما حذف شد";
            dispatch(setHasInvoiceAction(false));
          }
        } else {
          dispatch({
            type: FINAL_SUBMIT_CART,
            payload: {
              companyAddressId: addressId,
              companyAddressFloorId: floorId,
            },
          });
        }

        dispatch(getUserCreditAction());
        dispatch(setSettingAction());
        dispatch(getMenuCartAction(currentDayId, false)); // for update stock quantity
        callback({ success: true, message });
      })
      .catch((err) => {
        let message = "";
        if (err.errorCode !== "ERROR_CreditError") {
          dispatch(getMenuCartAction(currentDayId, true));
        }
        if (err.errorCode === "ERROR_CreditError") {
          callback(err);

          return;
        }
        if (err.errorCode === "ERROR_CreditErrorWithPayment") {
          callback(err);

          return;
        }

        if (err.errorCode === "ERROR_FoodStockNotEnough") {
          message = err.data.itemList
            .map(
              (f) =>
                `موجودی ${f.foodItemName} ${
                  f.foodStockQuantity > 0
                    ? `فقط ${f.foodStockQuantity} عدد`
                    : "به اتمام رسیده است"
                }`
            )
            .join("، ");

          dispatch(getMenuCartAction(currentDayId, false));
        }

        callback({
          success: false,
          message:
            message || err.message || "خطایی رخ داده است، دوباره تلاش کنید",
        });
      });
  };

export const changeAddressAction =
  ({ addressId, floorId }, callback = () => {}) =>
  (dispatch, getState) => {
    const dayId = getState().calendar.current.id;

    changeInvoiceAddress(dayId, addressId, floorId)
      .then(() => {
        dispatch({
          type: CHANGE_ADDRESS_CART,
          payload: { addressId, floorId },
        });
        callback({ success: true });
      })
      .catch((err) => {
        callback({ success: false, data: err });
      });
  };

export const updateCartQuantityAction =
  (food, quantity, callback = () => {}) =>
  (dispatch, getState) => {
    const list = getState().cart.list || [];
    const item = list?.find((i) => i.foodItemId === food.foodItemId);

    const newList = [];
    if (!item) {
      list.push({
        foodItemId: food.foodItemId,
        totalPrice: food.foodItemPrice * quantity,
        quantity,
        ...getMenuFoodItem(food),
      });
    } else {
      list.forEach((i) => {
        if (i.foodItemId === food.foodItemId) {
          if (quantity > 0) {
            newList.push({
              ...i,
              quantity,
              totalPrice: i.foodItemPrice * quantity,
            });
          }
        } else {
          newList.push(i);
        }
      });
    }

    dispatch({
      type: UPDATE_FOOD_LIST_CART,
      payload: item ? newList : list,
    });
    if (callback) {
      callback();
    }
  };

export const cancelEditCartAction = () => (dispatch, getState) => {
  const state = getState();

  const hasInvoice = state.setting.hasInvoice;
  const currentDayId = state.calendar.current.id;

  dispatch(exitEditModeAction());

  // remove all
  if (!hasInvoice) {
    dispatch(submitCartAction(true));
    dispatch(emptyQuantityMenuAction());
  }
  // get cart
  else {
    dispatch(getMenuCartAction(currentDayId, true));
  }
};

export const resetCartAction = () => ({
  type: RESET_CART,
  payload: true,
});

export const cancelPayment =
  (item, callback = () => {}) =>
  () => {
    calculateInvoice({
      dayId: item.dayId,
      ChangeInvoiceToNotPayedState: true,
      forSubmit: false,
      companyAddressId: 0,
      companyAddressFloorId: 0,
      foodItemIdQuantityList: [],
    })
      .then((result) => {
        if (result.success) {
          callback({ success: true });
        }
      })
      .catch((err) => {
        let message = "خطایی رخ داده است، دوباره تلاش کنید";
        if (err.errorCode === "ERROR_OrderingTimeIsOver") {
          message = err.message;
        }

        callback({ success: false, message });
      });
  };
